import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function SecurityPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Security"
        description="Ledger security practices. Your financial data is encrypted and securely stored in the cloud. Learn how we protect your business records."
        canonical="/security"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-surface-900 mb-4">Security</h1>
          <p className="text-lg text-surface-600">Bank-level security you can trust</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

